exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".oi-donation-form .footer .row[data-v-729d6a33]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;-webkit-box-orient:horizontal!important;-webkit-box-direction:normal!important;-ms-flex-direction:row!important;flex-direction:row!important;margin-bottom:5px;-webkit-filter:grayscale(1);filter:grayscale(1)}.oi-donation-form .footer .row .psp[data-v-729d6a33]{-webkit-box-flex:0;-ms-flex:0 0 30%;flex:0 0 30%;max-width:30%}.oi-donation-form .footer .apple-pay[data-v-729d6a33],.oi-donation-form .footer .card-notes[data-v-729d6a33]{font-size:12px;text-align:center}", ""]);

// exports
